import { ProfileForm } from "@stories/molecules/ProfileForm/ProfileForm";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "@hooks/context/useAuthContext";
import { useProfileContext } from "@hooks/context/useProfileContext";
import {
  ProfileLineItem,
  ProfileStatus,
  ProfileType,
} from "@interfaces/profile";
import * as RouteHelper from "@utils/routes";
import { PageBreadcrumbs } from "@stories/atoms/PageBreadcrumbs/PageBreadcrumbs";
import { SubTitle, SubTitleWithImage } from "@stories/atoms/SubTitle/SubTitle";
import { PageLoader } from "@stories/atoms/Loaders/PageLoader/PageLoader";
import { StyledCard } from "@stories/atoms/StyledCard/StyledCard";
import { Grid } from "@mui/material";
import { ToastOptions, toast } from "react-toastify";

export const Account = () => {
  const navigate = useNavigate();
  const { user } = useAuthContext();
  if (!user) {
    throw Error("No user in state.");
  }
  const { isProfileLoading, userProfile, userOrganisation, updateUserProfile } =
    useProfileContext();

  if (isProfileLoading || !userProfile || !userOrganisation) {
    console.log("ACCOUNT PAGE LOADER");
    return <PageLoader />;
  }

  const handleSubmit = async (profile: ProfileLineItem) => {
    try {
      if (userProfile) {
        await updateUserProfile(
          {
            ...userOrganisation,
            organisationLogo: userOrganisation.organisationLogoSrc,
          },
          { ...profile, status: ProfileStatus.Active }
        );
        if (profile?.status === ProfileStatus.Invited) {
          navigate(RouteHelper.listProjects);
        }
      }
      if (profile.status == ProfileStatus.Invited) {
        navigate(RouteHelper.listProjects);
      }
    } catch (e) {
      console.log(e);
      toast("Could not save account, please contact support.", {
        type: "error",
      } as ToastOptions);
    }
  };

  const title =
    userProfile.status !== ProfileStatus.Invited
      ? `${userOrganisation.tradingName} Account`
      : "Create Account";
  const breadcrumbs = [
    {
      path: RouteHelper.profile,
      name: "Profile",
    },
  ];
  return (
    <>
      {userProfile ? (
        <PageBreadcrumbs
          title={title}
          organisationLogo={userOrganisation.organisationLogo}
          links={breadcrumbs}
        />
      ) : null}
      <StyledCard>
        <Grid container spacing={2} sx={{ padding: "12px" }}>
          <Grid item xs={12} md={8}>
            <SubTitleWithImage
              title={title}
              url={userOrganisation.organisationLogo}
            />
          </Grid>
        </Grid>
      </StyledCard>
      <StyledCard>
        <Grid container spacing={2} sx={{ padding: "12px" }}>
          <Grid item xs={12} md={8}>
            <ProfileForm profile={userProfile} handleSubmit={handleSubmit} />
          </Grid>
        </Grid>
      </StyledCard>
    </>
  );
};
